import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { CustomizeFormModule } from 'src/app/shared/components/customize-form/customize-form.module';
import { EmptyModule } from 'src/app/shared/components/empty/empty.module';
import { ScrollbarModule } from 'src/app/shared/components/scrollbar/scrollbar.module';
import { LoadingModule } from 'src/app/shared/directive/loading/loading.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { WalletSelectCurrencyComponent } from './wallet-select-currency.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    EmptyModule,
    LoadingModule,
    ScrollbarModule,
    CustomizeFormModule,
    MatTabsModule,
    MatSlideToggleModule,
  ],
  declarations: [WalletSelectCurrencyComponent],
  exports: [WalletSelectCurrencyComponent],
})
export class WalletSelectCurrencyModule {}
